// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var ProjectName = function (x) {
    return x;
};
var tsBridgeProjectName = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("ProjectName")("__brandProjectName"));
    }
};
var writeProjectName = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showProjectName = Data_Show.showString;
var readProjectName = Simple_JSON.readString;
var ordProjectName = Data_Ord.ordString;
var newtypeProjectName = {
    Coercible0: function () {
        return undefined;
    }
};
var makeProjectName = ProjectName;
var eqProjectName = Data_Eq.eqString;
export {
    ProjectName,
    makeProjectName,
    unwrap,
    newtypeProjectName,
    eqProjectName,
    ordProjectName,
    showProjectName,
    readProjectName,
    writeProjectName,
    tsBridgeProjectName
};
//# sourceMappingURL=index.js.map
